module.exports = __webpack_public_path__ + "static/media/icon-status-confirmed.7da82b4f.svg";